import age1829 from '@/assets/quiz-age-18-29.png'
import age3039 from '@/assets/quiz-age-30-39.png'
import age4049 from '@/assets/quiz-age-40-49.png'
import age50plus from '@/assets/quiz-age-50-plus.png'
import Heading from '@app-studio-web/ui/components/Heading'
import { addAgeToLocalStorage } from '@app-studio-web/ui/helpers/localStorage'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import QuizLayout from './QuizLayout'

const TITLE = 'pages.quizOnboarding.age.title'
const SUBTITLE = 'pages.quizOnboarding.age.subtitle'

const ageCards: { labelKey: string; value: string; photo: string }[] = [
  {
    labelKey: 'pages.quizOnboarding.age.answer1',
    value: '18-29',
    photo: age1829,
  },
  {
    labelKey: 'pages.quizOnboarding.age.answer2',
    value: '30-39',
    photo: age3039,
  },
  {
    labelKey: 'pages.quizOnboarding.age.answer3',
    value: '40-49',
    photo: age4049,
  },
  {
    labelKey: 'pages.quizOnboarding.age.answer4',
    value: '50+',
    photo: age50plus,
  },
]

export default function AgePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.currentTarget.value
    if (selected) addAgeToLocalStorage(selected)
    submit(event.currentTarget.form)
  }

  return (
    <QuizLayout>
      <div className="shrink-0">
        <Heading subtitle={t(SUBTITLE)} title={t(TITLE)} />
      </div>

      <div className="flex grow flex-col justify-center">
        <Form
          className="mx-auto grid w-full max-w-sm grid-cols-2 gap-3"
          method="post"
        >
          {ageCards.map((card) => (
            <label
              key={card.value}
              className="group has-[:checked]:border-primary has-[:checked]:ring-primary relative flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-[#e2e8f0] bg-white shadow-sm transition-all hover:shadow-md has-[:checked]:ring-2"
            >
              <input
                className="sr-only"
                name={t(TITLE, { lng: 'en' })}
                onChange={handleChange}
                type="radio"
                value={card.value}
              />

              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  alt={t(card.labelKey)}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  src={card.photo}
                />
              </div>

              <span className="text-custom-black py-2 text-center text-sm font-bold">
                {t(card.labelKey)}
              </span>
            </label>
          ))}
        </Form>
      </div>
    </QuizLayout>
  )
}
